module.exports = __webpack_public_path__ + "static/media/folded-th.8494f42d.png";